import * as React from 'react';
import {DashboardRow} from './utils';
import PulsoidClient from '../../PulsoidClient';
import {Row} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faExternalLinkAlt} from '@fortawesome/free-solid-svg-icons';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import './index.css';
import prettyMilliseconds from 'pretty-ms';

export class Updates extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {updates: []};
  }

  componentDidMount() {
    new PulsoidClient()
      .getUpdates()
      .then(({updates}) => this.setState({updates}));
  }

  render() {
    return (
      <DashboardRow header={'Latest Updates'}>
        <Row>
          <Col className={'p-2'}>
            <div className={'p-2'}>
              <Table striped borderless hover>
                <tbody style={{margin: '5px'}}>
                  {this.state.updates.map((update, index) => {
                    return (
                      <tr
                        key={index}
                        onClick={() => window.open(update.link, '_blank')}
                        style={{cursor: 'pointer'}}
                      >
                        <td>
                          <h6 key={index}>{update.title}</h6>
                        </td>
                        <td>
                          <a href={update.link}>
                            {' '}
                            <FontAwesomeIcon icon={faExternalLinkAlt} />
                          </a>
                        </td>
                        <td>
                          {prettyMilliseconds(
                            new Date().getTime() - Date.parse(update.createdAt),
                            {
                              verbose: true,
                              compact: true,
                            }
                          )}{' '}
                          ago
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </Col>
        </Row>
      </DashboardRow>
    );
  }
}
